import{f as c}from"./__vite-currency.CSCTdhpv.js";import{e as y}from"./__vite-utils.DoIwWwgC.js";const m=(l,t)=>{const e=l||t||"";return l&&t&&t!=="Default Title"&&t!==l?`${l} - ${t}`:e};class b extends HTMLElement{constructor(){super(),this.itemsCount=null,this.headerPrice=null,this.stickyPrice=null,this.product=null,this.variant=null,this._subtotal=0,this._shipping=0,this._totalItems=0,this._bundles=[],this._addOns=[],this._addOns2=[],this._variantUpsells=[],this._productUpgrade=null,this.total=0,this.cart={cartSubtotal:0,cartTotal:0,cartLines:[]}}connectedCallback(){this.itemsCount=this.querySelector('[js-product-summary="count"]'),this.headerPrice=this.querySelector('[js-product-summary="headerPrice"]'),this.stickyPrice=document.querySelector('[js-product-form="sticky-price"]'),this.summaryControl=this.querySelector(".product-summary__control"),this.summaryControl=this.querySelector(".product-summary__control"),this.variantLine=this.querySelector('[js-product-summary="variant"]'),this.getVariantOnLoad(),this.setEventListeners(),this.updateTotal()}set subtotal(t){this._subtotal=t,this.updateTotal()}get subtotal(){return this._subtotal}get bundles(){return this._bundles}get variantUpsells(){return this._variantUpsells}get addOns(){return this._addOns}get addOns2(){return this._addOns2}get productUpgrade(){return this._productUpgrade}set shipping(t){this._shipping=t,this.updateTotal()}get shipping(){return this._shipping}get totalItems(){return this._totalItems}bundlesSetter(t){this._bundles=t,this.updateVariantLine()}variantUpsellsSetter(t){const{variant:e,selected:i}=t;i?this._variantUpsells=[...this._variantUpsells,e]:this._variantUpsells=this._variantUpsells.filter(a=>(a==null?void 0:a.id)!==(e==null?void 0:e.id)),this.updateVariantLine()}addOnsSetter(t){this._addOns=t,this.updateVariantLine()}addOns2Setter(t){this._addOns2=t,this.updateVariantLine()}productUpgradeSetter(t){this._productUpgrade=t,this.updateVariantLine()}setEventListeners(){this.summaryControl.addEventListener("click",()=>{this.toggleSummaryPanel()}),document.addEventListener("uwp-variant:update",t=>{const i=t.detail.variant;this.variant=i,this.updateVariantLine()}),y({eventName:"product-upsell:select",action:"listen",callback:t=>{const e=t;this.variantUpsellsSetter(e.detail)}}),y({eventName:"product-upsell:reset",action:"listen",callback:()=>{this._variantUpsells=[],this.updateVariantLine()}})}getVariantOnLoad(){const t=document.querySelector("uwp-product"),e=t==null?void 0:t._selectedVariant;this.product=t==null?void 0:t._product,setTimeout(()=>{const i=t._product;if(e)this.variant=e;else if(i!=null&&i.hasOnlyDefaultVariant){const a=i==null?void 0:i.variants[0];a.title=i==null?void 0:i.title,this.variant=a}this.updateVariantLine()},0)}getStockIndicator(t){const e=t.available?window.themeVars.strings.product.stock.inStock:window.themeVars.strings.product.stock.outOfStock;return t.available?`
        <div class="product-summary__stock">
          <span class="product-summary__stock-indicator product-summary__stock-indicator--in-stock"></span>
          <span class="product-summary__stock-label">${e}</span>
        </div>
      `:t.isPreorder?`
        <div class="product-summary__stock">
          <span class="product-summary__stock-indicator product-summary__stock-indicator--preorder"></span>
          <span class="product-summary__stock-label">${window.themeVars.strings.product.stock.preOrder}</span>
          <span class="product-summary__stock-label">${t.preorderDate}</span>
        </div>
      `:`
      <div class="product-summary__stock">
        <span class="product-summary__stock-indicator product-summary__stock-indicator--out-of-stock"></span>
        <span class="product-summary__stock-label">${e}</span>
      </div>
    `}updateVariantLine(){var a,d,p,h,_,g;if(!this.variant)return;const t=this.getStockIndicator(this.variant);let e="";const i=window.themeVars.config.currencyCodes.inPdp;if((a=this.product)!=null&&a.icon_label&&(e=`
        <div class="product-summary__icon-label">
          ${this.product.icon_label.icon?`<img
                src="${this.product.icon_label.icon}"
                width="16"
                height="16"
                alt=""
              />`:""}
          <span class="text-small">
            ${(p=(d=this.product)==null?void 0:d.icon_label)==null?void 0:p.label}
          </span>
        </div>
      `),this.variantLine&&this.bundles.length==0){const s=((h=this.variant)==null?void 0:h.compare_at_price)??0,r=this.variant.price,n=s>r,o=((_=this.variant)==null?void 0:_.imageAlt)||"";this.variantLine.innerHTML=`
        <div class="product-summary__item product-summary__item-variant">
          <div class="product-summary__item-image-wrapper">
            <img alt="${o}" src="${this.variant.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
          </div>
          <div class="product-summary__item-content">
            <div class="product-summary__item-details">
              <h6 class="product-summary__item-name text-large">
                ${((g=this.product)==null?void 0:g.title)||this.variant.title}
              </h6>
              ${t}
              ${e}
            </div>
            <div class="product-summary__item-price text-right ${n?"is-on-sale":""}">
              <span>
                <span class="visually-hidden">
                  ${window.themeVars.strings.product.price.sale}
                </span>

                ${n?`<span class="compare-at-price">
                        ${c({amount:s,inCents:!1,showCurrencyCode:i})}
                      </span>`:""}
              </span>

              <span>
                <span class="visually-hidden">
                  ${window.themeVars.strings.product.price.regular}
                </span>
                ${c({amount:r,inCents:!1,showCurrencyCode:i})}
              </span>
            </div>
          </div>
        </div>
      `}if(this.bundles.length>0&&(this.variantLine.innerHTML=this.bundles.map(s=>{var u,v;const r=Number(((u=s.compareAtPrice)==null?void 0:u.amount)||0),n=Number(s.price.amount),o=r>n;return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img src="${(v=s.image)==null?void 0:v.url}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${s.productTitle}
                  </h6>
                  ${t}
                </div>
                <div class="product-summary__item-price text-right ${o?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${o?`<span class="compare-at-price">
                            ${c({amount:r,inCents:!1,showCurrencyCode:i})}
                          </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${c({amount:n,inCents:!1,showCurrencyCode:i})}
                  </span>
                </div>
              </div>
            </div>
          `}).join("")),this.variantUpsells.length>0&&(this.variantLine.innerHTML+=this.variantUpsells.map(s=>{const r=s.compare_at_price??0,n=s.price,o=Number(r)>Number(n);return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img alt="${(s==null?void 0:s.imageAlt)||""}" src="${s.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${m(s.productTitle,s.title)}
                  </h6>
                  ${t}
                </div>
                <div class="product-summary__item-price text-right ${o?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${o?`<span class="compare-at-price">
                            ${c({amount:r,showCurrencyCode:i})}
                          </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${c({amount:n,showCurrencyCode:i})}
                  </span>
                </div>
              </div>
            </div>
          `}).join("")),this.addOns.length>0&&(this.variantLine.innerHTML+=this.addOns.map(s=>{const r=s.compare_at_price??0,n=s.price,o=Number(r)>Number(n);return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img alt="${(s==null?void 0:s.imageAlt)||""}" src="${s.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${m(s.productTitle,s.title)}
                  </h6>
                  ${t}
                </div>
                <div class="product-summary__item-price text-right ${o?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${o?`<span class="compare-at-price">
                            ${c({amount:r,inCents:!1,showCurrencyCode:i})}
                          </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${c({amount:n,inCents:!1,showCurrencyCode:i})}
                  </span>
                </div>
              </div>
            </div>
          `}).join("")),this.addOns2.length>0&&(this.variantLine.innerHTML+=this.addOns2.map(s=>{const r=s.compare_at_price??0,n=s.price,o=Number(r)>Number(n);return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img alt="${(s==null?void 0:s.imageAlt)||""}" src="${s.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${m(s.productTitle,s.title)}
                  </h6>
                  ${t}
                </div>
                <div class="product-summary__item-price text-right ${o?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${o?`<span class="compare-at-price">
                          ${c({amount:r,inCents:!1,showCurrencyCode:i})}
                        </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${c({amount:n,inCents:!1,showCurrencyCode:i})}
                  </span>
                </div>
              </div>
            </div>
          `}).join("")),this.productUpgrade){const s=this.productUpgrade,r=s.compare_at_price??0,n=s.price,o=Number(r)>Number(n),u=(s==null?void 0:s.imageAlt)||"";this.variantLine.innerHTML+=`
        <div class="product-summary__item product-summary__item-variant">
          <div class="product-summary__item-image-wrapper">
            <img alt="${u}" src="${s.imageUrl}?width=140&height=140" width="70" height="70" class="product-summary__item-image" />
          </div>
          <div class="product-summary__item-content">
            <div class="product-summary__item-details">
              <h6 class="product-summary__item-name text-large">
                ${s.productTitle||s.title}
              </h6>
            </div>
            <div class="product-summary__item-price text-right ${o?"is-on-sale":""}">
              <span>
                <span class="visually-hidden">
                  ${window.themeVars.strings.product.price.sale}
                </span>

                ${o?`<span class="compare-at-price">
                        ${c({amount:r,inCents:!1,showCurrencyCode:i})}
                      </span>`:""}
              </span>

              <span>
                <span class="visually-hidden">
                  ${window.themeVars.strings.product.price.regular}
                </span>

                ${c({amount:n,inCents:!1,showCurrencyCode:i})}
              </span>
            </div>
          </div>
        </div>
        ${this.getStockIndicator(s)}
      `}this.updateCartSubtotal()}toggleSummaryPanel(){const t=this.classList.toggle("is-active");this.summaryControl.setAttribute("aria-expanded",t.toString())}updateTotal(){this.total=this._subtotal+this._shipping,this.cart.cartSubtotal=this._subtotal,this.cart.cartTotal=this.total,this._totalItems=this.cart.cartLines.length,this.renderTotal(),this.renderHeaderPrice()}renderTotal(){const t=this.querySelector('[js-product-summary="total-value"]');if(!t)return;let e=this.bundles.length>0?0:this.total;this.bundles.forEach(a=>e+=Number(a.price.amount)),this.variantUpsells.forEach(a=>e+=Number(a.price)/100),this.addOns.forEach(a=>e+=Number(a.price)),this.addOns2.forEach(a=>e+=Number(a.price)),this.productUpgrade&&(e+=Number(this.productUpgrade.price));const i=window.themeVars.config.currencyCodes.inPdp;t.textContent=c({amount:e,inCents:!1,showCurrencyCode:i})}renderSubtotal(){const t=this.querySelector('[js-product-summary="subtotal-value"]');if(!t)return;let e=this.bundles.length>0?0:this._subtotal;this.bundles.forEach(a=>e+=Number(a.price.amount)),this.variantUpsells.forEach(a=>e+=Number(a.price)/100),this.addOns.forEach(a=>e+=Number(a.price)),this.addOns2.forEach(a=>e+=Number(a.price)),this.productUpgrade&&(e+=Number(this.productUpgrade.price)),t.textContent=c({amount:e,inCents:!1});const i=window.themeVars.config.currencyCodes.inPdp;t.textContent=c({amount:e,inCents:!1,showCurrencyCode:i})}renderItemsCount(){if(!this.itemsCount)return;const t=(this.bundles.length||1)+this.variantUpsells.length+this.addOns.length+this.addOns2.length+(this.productUpgrade?1:0);this.itemsCount.textContent=`(${t})`}renderHeaderPrice(){if(!this.headerPrice)return;let t=this.bundles.length>0?0:this.total;if(this.bundles.forEach(i=>t+=Number(i.price.amount)),this.variantUpsells.forEach(i=>t+=Number(i.price)/100),this.addOns.forEach(i=>t+=Number(i.price)),this.addOns2.forEach(i=>t+=Number(i.price)),this.productUpgrade&&(t+=Number(this.productUpgrade.price)),!t)return;const e=window.themeVars.config.currencyCodes.inPdp;this.headerPrice.textContent=c({amount:t,inCents:!1,showCurrencyCode:e}),this.stickyPrice&&(this.stickyPrice.textContent=c({amount:t,inCents:!1,showCurrencyCode:e}))}addProductLine(t){this.cart.cartLines.push(t),this.updateCartSubtotal()}removeProductLine(t){this.cart.cartLines=this.cart.cartLines.filter(e=>e.id!==t),this.updateCartSubtotal()}updateCartSubtotal(){this._subtotal=this.cart.cartLines.reduce((t,e)=>t+e.price,0),this._subtotal+=this.variant?Number(this.variant.price):0,this.renderSubtotal(),this.renderItemsCount(),this.renderHeaderPrice(),this.updateTotal()}}customElements.define("uwp-product-summary",b);
